define("shared/components/shared/post/profile-selector/profile-list/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul
    class={{concat-classes
      "cCP--list"
      (if @isAvailableList "qa--modal_available_profileList" "qa--modal_notAvailable_profileList")
    }}
  >
    {{#if @isAvailableList}}
      {{#each @socialProfileStates as |state|}}
        <Shared::Post::ProfileSelector::AvailableProfile
          @profile={{state.socialProfile}}
          @state={{state}}
          @toggleSelectProfile={{@toggleSelectProfile}}
        />
      {{/each}}
    {{else}}
      {{#each @socialProfileStates as |state|}}
        <Shared::Post::ProfileSelector::UnavailableProfile
          @closeAction={{@closeAction}}
          @profile={{state.socialProfile}}
          @state={{state}}
        />
      {{/each}}
    {{/if}}
  </ul>
  */
  {
    "id": "8Qtc+d3w",
    "block": "[[[10,\"ul\"],[15,0,[28,[37,0],[\"cCP--list\",[52,[30,1],\"qa--modal_available_profileList\",\"qa--modal_notAvailable_profileList\"]],null]],[12],[1,\"\\n\"],[41,[30,1],[[[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[1,\"      \"],[8,[39,4],null,[[\"@profile\",\"@state\",\"@toggleSelectProfile\"],[[30,3,[\"socialProfile\"]],[30,3],[30,4]]],null],[1,\"\\n\"]],[3]],null]],[]],[[[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[1,\"      \"],[8,[39,5],null,[[\"@closeAction\",\"@profile\",\"@state\"],[[30,6],[30,5,[\"socialProfile\"]],[30,5]]],null],[1,\"\\n\"]],[5]],null]],[]]],[13]],[\"@isAvailableList\",\"@socialProfileStates\",\"state\",\"@toggleSelectProfile\",\"state\",\"@closeAction\"],false,[\"concat-classes\",\"if\",\"each\",\"-track-array\",\"shared/post/profile-selector/available-profile\",\"shared/post/profile-selector/unavailable-profile\"]]",
    "moduleName": "shared/components/shared/post/profile-selector/profile-list/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});